import { useCallback } from 'react';
import type { GadgetColor } from '@atlassian/jira-dashboard-common/src/types.tsx';
import { lensGadget } from '@atlassian/jira-dashboard-internal-common/src/utils/dashboard-config-lenses/index.tsx';
import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { useDashboardResource } from '@atlassian/jira-router-resources-dashboard/src/index.tsx';

export const useSaveGadgetColor = (id: string) => {
	const { data, update } = useDashboardResource();

	return useCallback(
		async (newColorId: GadgetColor) => {
			if (!data) {
				return;
			}
			const colorUrl = `/rest/dashboards/1.0/${data.id}/gadget/${id}/color`;

			await performPutRequest(colorUrl, {
				body: JSON.stringify({ color: newColorId }),
			});

			update(lensGadget(id, { color: newColorId }));
		},
		[data, id, update],
	);
};
